export default function isDarkColor(color: string | null): boolean {
  if (!color) {
    return false
  }

  let r: number
  let g: number
  let b: number

  // Check if the color is in RGB format
  const rgbMatch = color.match(
    /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/,
  )
  if (rgbMatch) {
    // If RGB(A) --> Extract the red, green, blue values from the regex match
    r = Number.parseInt(rgbMatch[1], 10)
    g = Number.parseInt(rgbMatch[2], 10)
    b = Number.parseInt(rgbMatch[3], 10)
  } else {
    // If HEX --> Convert it to RGB values
    const hex =
      color.length === 4
        ? Number.parseInt(
            color.slice(1).replace(/./g, (c) => c + c),
            16,
          ) // Handle short HEX like #abc
        : Number.parseInt(color.slice(1), 16) // Handle full HEX like #aabbcc
    r = (hex >> 16) & 255
    g = (hex >> 8) & 255
    b = hex & 255
  }

  // Calculate the brightness (HSP value)
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b))

  // Return true if the color is dark, otherwise false
  return hsp <= 150
}
